























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  public voices: SpeechSynthesisVoice[] = window.speechSynthesis.getVoices();
  public selectVoice: number|null = null;
  public inputValue: string = '';
  public created() {
    window.speechSynthesis.onvoiceschanged = () => {
      this.voices = window.speechSynthesis.getVoices();
      if (this.voices.length === 0) {
        alert('You don\'t have speechSynthesis');
      }
    };
  }
  public speech() {
    if (this.selectVoice === null) {
      return;
    }
    window.speechSynthesis.cancel();
    const voice = this.selectVoice;
    this.inputValue.split(/\r\n|\r|\n/).forEach((v: string) => {
      const utter = new SpeechSynthesisUtterance(v);
      utter.voice = this.voices[voice];
      window.speechSynthesis.speak(utter);
    });
  }
}
